import moment from 'moment';

export default {
    data() {
        return {
            last90Days: {
                text: this.$t("servicesystem.common_objects.commonterms.datetime.last_90_days"),
                onClick(picker) {
                    const start = moment().subtract(90, 'days');
                    const end = moment();
                    picker.$emit('pick', [start, end]);
                }
            },
        };
    },

    methods: {
        outputRelativeRange(subtraction, unit) {
            var date = moment();
            date.subtract(subtraction, unit);
            const end = moment(date).endOf(unit).toDate();
            const start = moment(date).startOf(unit).toDate();
            return [start, end];
        },

        asElementUIRange(subtraction, unit, displaytext) {
            var range = this.outputRelativeRange(subtraction, unit);
            return {
                text: displaytext,
                range: range,
                onClick(picker) {
                    picker.$emit('pick', range);
                }
            }
        },
    },

    computed: {
        thisWeek() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.this_week");
            return this.asElementUIRange(0, 'isoWeek', text);
        },
        lastWeek() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.last_week");
            return this.asElementUIRange(1, 'isoWeek', text);
        },
        thisMonth() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.this_month");
            return this.asElementUIRange(0, 'month', text);
        },
        lastMonth() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.last_month");
            return this.asElementUIRange(1, 'month', text);
        },
        thisYear() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.this_year");
            return this.asElementUIRange(0, 'year', text);
        },
        lastYear() {
            var text = this.$t("servicesystem.common_objects.commonterms.datetime.last_year");
            return this.asElementUIRange(1, 'year', text);
        },

    }
}